<!--banner informativo-->
<div class="content-banner d-flex">
  <div class="content-banner-information">
    <label-block [info]="BanerFirstTab"></label-block>
  </div>
  <img class="img-banner" src="../../../../assets/images/contactanos.png" alt="img-information" />
</div>

<div class="tittle">
  <section-header [data]="dataHeader"></section-header>
</div>
<div class="contactos">
  <div class="card-container d-flex flex-row col-md-12 col-sm-12 justify-content-center">
    <a target="_blank" *ngFor="let card of cardsContactos">
      <div class="{{ card.line }}">
        <hr class="clearfix w-100 d-md-none pb-3" />
        <contactos-card [cardInfo]="card"></contactos-card>
      </div>
    </a>
  </div>
</div>

<div class="">
  <div class="content-contact d-block justify-content-center">
    <div class="content-banner-information">
      <ul class="no-padding">
        <label-block [info]="Correo"></label-block>
      </ul>
    </div>
    <app-form></app-form>
  </div>
  <div class="content-banner-information">
    <ul class="no-padding">
      <label-block [info]="Recursos"></label-block>
    </ul>
  </div>

  <div class="icons-pqr d-flex justify-content-center">
    <div class="col-md-2 pqr">
      <a routerLink="/pqr/menuCiudadano"><img class="logo-azul"
          src="../../../../assets/images/iconos/buzon_1.svg" /></a>
      <p>PQRS<br /></p>
    </div>
    <div class="col-md-2 pqr" style="display: none;">
      <a href="#" target="_blank" rel="noopener noreferrer"><img class="svg-icon"
          src="../../../../assets/images/iconos/buzon_1.svg" /></a>
      <p>PQRS (Anónima) <br /></p>
    </div>
  </div>
</div>